<mat-tab-group class="tabs-group edit-order-grp">
  <mat-tab label="Realtor">
    <div class="container-fluid glb-popup">
      <h2> {{formTitle}}</h2>
      <p-toast [style]="{marginTop: '80px'}">
      </p-toast>
      <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

      <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
      <hr>
        <div [formGroup]="form1" class="forms w-100 d-block">
          <div class="row m-0">

            <div class="col-lg-12">
              @if (formAlert) {
                <div class="w-100 mb-3">
                  <div class="w-100"
                    style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                    <p><b>{{formAlert}}</b></p>
                  </div>
                </div>
              }
            </div>

            <div class="col-lg-6">
              <span class="p-float-label required-field w-100 mb-3">
                <p-dropdown [options]="listingStatuses" formControlName="listingStatus" optionLabel="name"
                  optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
                placeholder="Select Status"></p-dropdown>
                <label for="Select Status">Select Status</label>
                @for (validation of validationMessages.listingStatus; track validation) {
                  <span>
                    @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6"></div>

            <div class="col-lg-2">
              <span class="p-float-label required-field w-100 mb-3"
                >
                <p-dropdown
                  class="w-100"
                  [options]="titles"
                  formControlName="title"
                  optionLabel="name"
                  optionValue="value"
                  placeholder="Titles"
                ></p-dropdown>
                <label for="title">Title</label
                  >@for (validation of validationMessages.title; track validation) {
                  <span
                    >@if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                    }</span
                    >
                    }</span
                    >
                  </div>

                  <div class="col-lg-4">
                    <span class="p-float-label required-field w-100 mb-3">
                      <input formControlName="firstName" id="firstName" type="text" pInputText>
                      <label for="firstName">First Name</label>
                      @for (validation of validationMessages.firstName; track validation) {
                        <span>
                          @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>

                  <div class="col-lg-4">
                    <span class="p-float-label required-field w-100 mb-3">
                      <input formControlName="lastName" id="lastName" type="text" pInputText>
                      <label for="lastName">Last Name</label>
                      @for (validation of validationMessages.lastName; track validation) {
                        <span>
                          @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>

                  <div class="col-lg-2">
                    <span class="p-float-label required-field w-100 mb-3">
                      <input formControlName="suffix" id="suffix" type="text" pInputText>
                      <label for="suffix">Suffix</label>
                      @for (validation of validationMessages.suffix; track validation) {
                        <span>
                          @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>



                  <div class="col-lg-6">
                    <span class="p-float-label required-field w-100 mb-3">
                      <input formControlName="emailAddress" id="emailAddress" type="email" pInputText>
                      <label for="emailAddress">Email Address</label>
                      @for (validation of validationMessages.emailAddress; track validation) {
                        <span>
                          @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>

                  <div class="col-lg-6">
                    <span class="p-float-label required-field w-100 mb-3">
                      <!-- <p-inputMask formControlName="mobilePhone" id="mobilePhone" mask="(999) 999-9999" type="text">
                    </p-inputMask> -->
                    <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
                    <label for="mobilePhone">Mobile Phone</label>
                    @for (validation of validationMessages.mobilePhone; track validation) {
                      <span>
                        @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-6">
                  <span class="p-float-label required-field w-100 mb-3">
                    <input formControlName="licenseNum" id="licenseNum" type="text" pInputText>
                    <label for="licenseNum">License Number</label>
                    @for (validation of validationMessages.licenseNum; track validation) {
                      <span>
                        @if (form1.get('licenseNum').hasError(validation.type) && (form1.get('licenseNum').dirty || form1.get('licenseNum').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-6">
                  <span class="p-float-label w-100 mb-3">
                    <p-dropdown class="w-100" [options]="agntSaleSidePrefs" formControlName="agntSaleSidePref" optionLabel="name"
                    optionValue="value" placeholder="Are you primarily a Buyer’s Agent, Listing Agent, or Both?"></p-dropdown>
                    <label for="Are you primarily a Buyer’s Agent, Listing Agent, or Both?">Are you primarily a Buyer’s Agent, Listing Agent, or Both?</label>
                    @for (validation of validationMessages.agntSaleSidePref; track validation) {
                      <span>
                        @if (form1.get('agntSaleSidePref').hasError(validation.type) && (form1.get('agntSaleSidePref').dirty || form1.get('agntSaleSidePref').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-12">
                  <span class="p-float-label w-100 mb-3">
                    <p-dropdown class="w-100" [options]="agntLeadsPrefs" id="agntLeadsPref" formControlName="agntLeadsPref" optionLabel="name"
                    optionValue="value" placeholder="Would you like to join our customer referral program?  If so, select the types of leads you are most successful:"></p-dropdown>
                    <label for="agntLeadsPref">Would you like to join our customer referral program?  If so, select the types of leads you are most successful:</label>
                    @for (validation of validationMessages.agntLeadsPref; track validation) {
                      <span>
                        @if (form1.get('agntLeadsPref').hasError(validation.type) && (form1.get('agntLeadsPref').dirty || form1.get('agntLeadsPref').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-4">
                  <span class="p-float-label w-100 mb-3">
                    <p-dropdown class="w-100" [options]="statuses" formControlName="adrType" optionLabel="name"
                    optionValue="value" placeholder="Select Address Type"></p-dropdown>
                    <label for="Select Address Type">Select Address Type</label>
                    @for (validation of validationMessages.adrType; track validation) {
                      <span>
                        @if (form1.get('adrType').hasError(validation.type) && (form1.get('adrType').dirty || form1.get('adrType').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-8">
                  <span class="p-float-label required-field w-100 mb-3">
                    <input formControlName="adrCompanyName" id="adrCompanyName" type="text" pInputText>
                    <label for="adrCompanyName">Adr Company Name</label>
                    @for (validation of validationMessages.adrCompanyName; track validation) {
                      <span>
                        @if (form1.get('adrCompanyName').hasError(validation.type) && (form1.get('adrCompanyName').dirty || form1.get('adrCompanyName').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-12">
                  <span class="p-float-label required-field w-100 mb-3">
                    <input formControlName="adrStreet" id="adrStreet" type="text" pInputText>
                    <label for="adrStreet">Adr Street</label>
                    @for (validation of validationMessages.adrStreet; track validation) {
                      <span>
                        @if (form1.get('adrStreet').hasError(validation.type) && (form1.get('adrStreet').dirty || form1.get('adrStreet').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-12">
                  <span class="p-float-label required-field w-100 mb-3">
                    <input formControlName="adrStreet2" id="adrStreet2" type="text" pInputText>
                    <label for="adrStreet2">Adr Street2</label>
                    @for (validation of validationMessages.adrStreet2; track validation) {
                      <span>
                        @if (form1.get('adrStreet2').hasError(validation.type) && (form1.get('adrStreet2').dirty || form1.get('adrStreet2').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-5">
                  <span class="p-float-label required-field w-100 mb-3">
                    <input formControlName="adrCity" id="adrCity" type="text" pInputText>
                    <label for="adrCity">Adr City</label>
                    @for (validation of validationMessages.adrCity; track validation) {
                      <span>
                        @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-2">
                  <span class="p-float-label required-field w-100 mb-3">
                    <p-dropdown [options]="states" formControlName="adrState" optionLabel="name" appendTo="body"
                      optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
                      placeholder="State">
                    </p-dropdown>
                    <label for="adrState">Adr State</label>
                    @for (validation of validationMessages.adrState; track validation) {
                      <span>
                        @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-2">
                  <span class="p-float-label required-field w-100 mb-3">
                    <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
                    <label for="adrPostalCode">Adr Postal Code</label>
                    @for (validation of validationMessages.adrPostalCode; track validation) {
                      <span>
                        @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-lg-3">
                  <span class="p-float-label required-field w-100 mb-3">
                    <p-dropdown [options]="countries" formControlName="adrCountry" optionLabel="name" appendTo="body"
                      optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
                      placeholder="Country">
                    </p-dropdown>
                    <label for="adrCountry">Adr Country</label>
                    @for (validation of validationMessages.adrCountry; track validation) {
                      <span>
                        @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>



                <div class="col-lg-6">
                  <span class="p-float-label required-field w-100 mb-3">
                    <!-- <p-inputMask formControlName="adrPhone" id="adrPhone" mask="(999) 999-9999" type="text">
                  </p-inputMask> -->
                  <input formControlName="adrPhone" id="adrPhone" type="text" pInputText>
                  <label for="adrPhone">Adr Phone</label>
                  @for (validation of validationMessages.adrPhone; track validation) {
                    <span>
                      @if (form1.get('adrPhone').hasError(validation.type) && (form1.get('adrPhone').dirty || form1.get('adrPhone').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="adrFax" id="adrFax" type="text" pInputText>
                  <label for="adrFax">Adr Fax</label>
                  @for (validation of validationMessages.adrFax; track validation) {
                    <span>
                      @if (form1.get('adrFax').hasError(validation.type) && (form1.get('adrFax').dirty || form1.get('adrFax').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="family" id="family" type="text" pInputText>
                  <label for="family">Family</label>
                  @for (validation of validationMessages.family; track validation) {
                    <span>
                      @if (form1.get('family').hasError(validation.type) && (form1.get('family').dirty || form1.get('family').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="favSports" id="favSports" type="text" pInputText>
                  <label for="favSports">Fav Sports</label>
                  @for (validation of validationMessages.favSports; track validation) {
                    <span>
                      @if (form1.get('favSports').hasError(validation.type) && (form1.get('favSports').dirty || form1.get('favSports').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="education" id="education" type="text" pInputText>
                  <label for="education">Education</label>
                  @for (validation of validationMessages.education; track validation) {
                    <span>
                      @if (form1.get('education').hasError(validation.type) && (form1.get('education').dirty || form1.get('education').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="politics" id="politics" type="text" pInputText>
                  <label for="politics">Politics</label>
                  @for (validation of validationMessages.politics; track validation) {
                    <span>
                      @if (form1.get('politics').hasError(validation.type) && (form1.get('politics').dirty || form1.get('politics').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="contactPref" id="contactPref" type="text" pInputText>
                  <label for="contactPref">Contact Pref</label>
                  @for (validation of validationMessages.contactPref; track validation) {
                    <span>
                      @if (form1.get('contactPref').hasError(validation.type) && (form1.get('contactPref').dirty || form1.get('contactPref').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              @if (isDisplayRealtorProfile) {
                <div class="col-lg-2 d-flex justify-content-end">
                  <label>Portal Access : </label>
                </div>
              }
              @if (isDisplayRealtorProfile) {
                <div class="col-lg-4">
                  <span class="p-float-label required-field w-100 mb-3">
                    <p-selectButton [options]="portalAccesses" formControlName="portalAccessBasic" (onChange)="updateRealtorPortalAccess()" optionLabel="name" optionValue="value"></p-selectButton>
                    @for (validation of validationMessages.portalAccessBasic; track validation) {
                      <span>
                        @if (form1.get('portalAccessBasic').hasError(validation.type) && (form1.get('portalAccessBasic').dirty || form1.get('portalAccessBasic').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              }
              @if (!isDisplayRealtorProfile) {
                <div class="col-lg-6"></div>
              }

              <div class="col-lg-12">
                <span class="p-float-label w-100 mb-3">
                  <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
                  <label for="opsNotes">Ops Notes</label>
                  @for (validation of validationMessages.opsNotes; track validation) {
                    <span>
                      @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

            </div>
          </div>

          <hr>

            @if (realtorProfileId) {
              <div>
                <div class="col-lg-12">
                  <h6>Proforma</h6>
                </div>
                @if (realtorProfileId) {
                  <app-proforma-list [realtorProfileId]="realtorProfileId" [showFilter]="false"
                  [showPagination]="false"></app-proforma-list>
                }
              </div>
            }

            <hr>

              <div class="row m-0">
                <div class="col-lg-12">
                  <div class="btn-group">
                    <div class="button-group">
                      @if (realtorProfileId) {
                        <button pButton class="btn-delete p-button-outlined p-button-danger"
                        (click)="onFormDelete()">Delete RealtorProfile</button>
                      }
                    </div>

                    <div class="button-group">
                      <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                      @if (!realtorProfileId) {
                        <button pButton class="btn-addt p-button" (click)="formAdd()">Add RealtorProfile</button>
                      }

                      @if (realtorProfileId) {
                        <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update RealtorProfile</button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Email & Text">
            <!--
            parameter passed and stage based on that SMS or mail template is sent
            now that we have live merge of template we dont need custom message sending from custom buttons
            -->
            <!-- <button pButton class="btn-addt p-button" (click)="sendGuestComm( 100)">Send welCome Checkin</button>
            <button pButton class="btn-addt p-button" (click)="sendGuestComm(200)">Send Day After Checkin</button>
            <button pButton class="btn-addt p-button" (click)="sendGuestComm(300)">Send Day Before Checkout</button>
            <button pButton class="btn-addt p-button" (click)="sendGuestComm(400)">Send Day After Checkout</button>
            <button pButton class="btn-addt p-button" (click)="sendGuestComm(500)">Send Week After Checkout</button>-->



            @if (isRealtorLoaded) {
              <app-inbox-list-guest [msgTopic]="510" [msgTemplateData]="msgTemplateData" [msgTopicId]="realtorProfileId" [realtorProfileId]="realtorProfileId"></app-inbox-list-guest>
            }
          </mat-tab>
        </mat-tab-group>
